import { render, staticRenderFns } from "./hot-pc.vue?vue&type=template&id=3cc5d12e&scoped=true&"
import script from "./hot-pc.vue?vue&type=script&lang=js&"
export * from "./hot-pc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc5d12e",
  null
  
)

export default component.exports